import BASE_URL from './config';

// Interceptor global: adjunta el JWT (Authorization: Bearer) a toda petición
// dirigida a la API y cierra sesión automáticamente ante un 401/403.
// Se importa una sola vez en index.js — evita repetir headers en cada fetch.
const originalFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApiCall = url.startsWith(BASE_URL) || url.startsWith('/');

    if (isApiCall) {
        const token = localStorage.getItem('token');
        if (token) {
            init.headers = { ...(init.headers || {}), Authorization: `Bearer ${token}` };
        }
    }

    const response = await originalFetch(input, init);

    // Solo 401 = sesión ausente/inválida/expirada → cerrar sesión y volver al login.
    // El 403 (sin permiso) NO desloguea: lo maneja el componente mostrando el mensaje.
    // Se excluyen los endpoints de login/2FA: ahí un 401 significa
    // "credenciales inválidas", no "sesión caducada".
    const isAuthEndpoint = url.includes('/auth/') || url.includes('/2fa/');
    if (isApiCall && !isAuthEndpoint && response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/home';
    }

    return response;
};
